import Super from 'ember-simplepractice/components/shared/onboarding-popover';
import classic from 'ember-classic-decorator';
import styles from './onboarding-popover.module.scss';

@classic
export default class SharedOnboardingPopover extends Super {
  init() {
    super.init(...arguments);
    this.styles.component += ' ' + styles.component;
  }
}
